module.exports = __webpack_public_path__ + "img/consultant.77a12089.png";